import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserInfo } from "../pages/User/requests/userRequests";
import { CONTRAST_ENUM } from "../pages/SettingsPage/constants/constants";
import { loadPersistedUserSettings } from "./userSettingsStorage";

export interface UserInfoState {
  timerSound: boolean;
  soundEffects: boolean;
  fontSize: "small" | "standard" | "large" | "very-large";
  contrast: CONTRAST_ENUM;
  showPictures: boolean;
  userData: UserInfo | null;
  email: string | null;
  userName: string | null;
}

const initialState: UserInfoState = {
  timerSound: false,
  soundEffects: true,
  fontSize: "standard",
  contrast: CONTRAST_ENUM.STANDARD,
  showPictures: true,
  userData: null,
  email: null,
  userName: null,
};

const savedSettings = loadPersistedUserSettings();
const initialUserInfoState: UserInfoState = {
  ...initialState,
  ...savedSettings,
};

const userInfoSlice = createSlice({
  name: "userInfo",
  initialState: initialUserInfoState,
  reducers: {
    setUserData: (state, action: PayloadAction<UserInfo | null>) => {
      state.userData = action.payload;
    },
    setUserAuthInfo: (
      state,
      action: PayloadAction<{ email: string; userName: string } | null>,
    ) => {
      if (action.payload) {
        state.email = action.payload.email;
        state.userName = action.payload.userName;
      } else {
        state.email = null;
        state.userName = null;
      }
    },
    updateTimerSound: (state, action: PayloadAction<boolean>) => {
      state.timerSound = action.payload;
    },
    updateSoundEffects: (state, action: PayloadAction<boolean>) => {
      state.soundEffects = action.payload;
    },
    updateFontSize: (
      state,
      action: PayloadAction<"small" | "standard" | "large" | "very-large">,
    ) => {
      state.fontSize = action.payload;
    },
    updateContrast: (state, action: PayloadAction<CONTRAST_ENUM>) => {
      state.contrast = action.payload;
    },
    updateShowPictures: (state, action: PayloadAction<boolean>) => {
      state.showPictures = action.payload;
    },
    loadSettingsFromStorageAction: (state) => {
      Object.assign(state, loadPersistedUserSettings());
    },
  },
});

export const {
  setUserData,
  setUserAuthInfo,
  updateTimerSound,
  updateSoundEffects,
  updateFontSize,
  updateContrast,
  updateShowPictures,
  loadSettingsFromStorageAction,
} = userInfoSlice.actions;

export default userInfoSlice.reducer;
